var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "go-channel-header" }, [
    _c("ul", { staticClass: "nav go-tab-line" }, [
      _c("li", { staticClass: "go-tab-item" }, [
        _c(
          "a",
          {
            staticClass: "go-tab-link active",
            attrs: { "data-toggle": "tab" },
          },
          [_vm._v("All (" + _vm._s(_vm.totalItems) + ")")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }